import CommonNotificationSettingChange from '../../../common/pages/secure/NotificationSettingChange'

class NotificationSettingChange extends CommonNotificationSettingChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
}

export default NotificationSettingChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/NotificationSettingChange.js